'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = createRequestError;
/**
 * Formats an error response from GraphQL server request.
 */
function formatRequestErrors(request, errors) {
  var CONTEXT_BEFORE = 20;
  var CONTEXT_LENGTH = 60;

  if (!request.getQueryString) {
    return errors.join('\n');
  }

  var queryLines = request.getQueryString().split('\n');
  return errors.map(function (_ref, ii) {
    var locations = _ref.locations,
        message = _ref.message;

    var prefix = ii + 1 + '. ';
    var indent = ' '.repeat(prefix.length);

    // custom errors thrown in graphql-server may not have locations
    var locationMessage = locations ? '\n' + locations.map(function (_ref2) {
      var column = _ref2.column,
          line = _ref2.line;

      var queryLine = queryLines[line - 1];
      var offset = Math.min(column - 1, CONTEXT_BEFORE);
      return [queryLine.substr(column - 1 - offset, CONTEXT_LENGTH), ' '.repeat(Math.max(offset, 0)) + '^^^'].map(function (messageLine) {
        return indent + messageLine;
      }).join('\n');
    }).join('\n') : '';
    return prefix + message + locationMessage;
  }).join('\n');
}

function createRequestError(request, requestType, responseStatus, payload) {
  var errorReason = void 0;
  if ((typeof payload === 'undefined' ? 'undefined' : _typeof(payload)) === 'object' && payload.errors) {
    errorReason = formatRequestErrors(request, payload.errors);
  } else if (payload) {
    errorReason = payload;
  } else {
    errorReason = 'Server response had an error status: ' + responseStatus;
  }

  var error = void 0;
  if (request.getDebugName) {
    // for native Relay request
    error = new Error('Server request for ' + requestType + ' `' + request.getDebugName() + '` ' + ('failed for the following reasons:\n\n' + errorReason));
  } else if (request && (typeof request === 'undefined' ? 'undefined' : _typeof(request)) === 'object') {
    // for batch request
    var ids = Object.keys(request);
    error = new Error('Server request for `BATCH_QUERY:' + ids.join(':') + '` ' + ('failed for the following reasons:\n\n' + errorReason));
  } else {
    error = new Error('Server request failed for the following reasons:\n\n' + errorReason);
  }

  error.source = payload;
  error.status = responseStatus;
  return error;
}


//////////////////
// WEBPACK FOOTER
// ./~/react-relay-network-layer/lib/createRequestError.js
// module id = 1505
// module chunks = 0